import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDResponse } from '../responses/device-inbox-registration-token-controller-get-token-by-user-uuid.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'device-inbox-registration-token-controller-getTokenByUserUUID',
    operation: '{"operationId":"device-inbox-registration-token-controller-getTokenByUserUUID","responses":{"200":{"content":{"application/json":{"schema":{"type":"object","properties":{"uuid":{"type":"string","format":"uuid"},"registrationToken":{"type":"string"},"user":{"$ref":"#/components/schemas/User"},"expiresAt":{"type":"integer","format":"int64"}}}}}}},"method":"get","path":"/device-inbox-regtoken-controller/get"}'
  })
export class DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDRemoteMethod extends OpenApiRemoteMethod<DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDResponse, void, void> {
  public override call(): Promise<DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDResponse> {
    return super.call();
  }
}
